import { useEffect } from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';

import initApp from 'src/hooks/initApp';

const propTypes = {
  route: PropTypes.string.isRequired,
};

const Scripts = ({ route }) => {
  // This is the equivalent of importing app.js
  useEffect(() => {
    initApp({ route });

    return () => {
      // remove all scroll and resize events from the window object
      // prevents memory leaks and thousands of errors in sentry
      $(window).off();
    };
  }, [route]);

  return null;
};

Scripts.propTypes = propTypes;
export default Scripts;
